import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingBarService } from '@ngx-loading-bar/core';

@Injectable()
export class LoadingBarInterceptor implements HttpInterceptor {

  constructor(private loadingBarService: LoadingBarService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingBarService.start();
    return next.handle(req).pipe(finalize(() => this.loadingBarService.complete()));
  }
}
